
function validateMessages(messages, validationUrl) {
    const VALIDATION_TIMEOUT = 2000;
    var promises = []

    for(var i in messages) {
        var xmlHttp = new XMLHttpRequest();
        xmlHttp.open("POST", validationUrl);
        xmlHttp.send(messages[i].Data);

        promises.push(new Promise(function (resolve, reject) {
            xmlHttp.onload = function () {
                if(xmlHttp.status == 202) {
                    console.warn(`${JSON.parse(messages[i].Data).name} fails data guild validation: ${xmlHttp.responseText}`);
                } else if(xmlHttp.status == 500) {
                    console.warn(`Error occurred in data guild validation for ${messages[i].Data.Name}: ${JSON.parse(response.responseText).error}`);
                }
                resolve();
            };
            setTimeout(function () { resolve() }, VALIDATION_TIMEOUT)
        }))
    }

    return Promise.all(promises);
}

module.exports = {
    validateMessages
}